import httpClient from '../httpClient';

const post = async (data) => {
    return await httpClient.post(`/resource/`, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

const getAll = async (data) => {
    return await httpClient.get(`/resource/?sort=-created_at`);
};

const getAllByUser = async (data) => {
    return await httpClient.get(`/resource/?filter[user]=${localStorage["id"]}`);
};

const get = async (id) => {
    return await httpClient.get(`/resource/${id}/`);
};

const patch = async (id, data) => {
    return await httpClient.patch(`/resource/${id}/`, data);
};

const generateUrl = async (id) => {
    return await httpClient.get(`/resource/${id}/signed_url/`);
};

const remove = async (id) => {
    return await httpClient.delete(`/resource/${id}/`);
};

export {
    post,
    patch,
    getAll,
    getAllByUser,
    get,
    generateUrl,
    remove,
};